import { useState, useMemo, useEffect } from "react";
import { useHistory, useParams } from "react-router";

import { PAGES } from "../../../constants";
import { useSopById } from "../../../hooks/useSopById";
import useQueryNotFoundNavigation from "../../../hooks/navigation/useQueryNotFoundNavigation";
import useAssociatedFiles from "../../../hooks/useAssociatedFiles";
import { useAppState } from "../../../state/appState";
import useWidgetTabNavigation from "../../../hooks/useWidgetTabNavigation";

const useDetailsVersionData = () => {
  const history = useHistory();
  const [{ systemConfiguration }] = useAppState();
  const { sopId, versionId: version } = useParams();
  const { data: sop, isLoading: loading, error } = useSopById(sopId, version);
  const params = useMemo(() => ({ association: `Sop/${sopId}` }), [sopId]);
  const { associatedFiles } = useAssociatedFiles(params);
  const [showActivity, setShowActivity] = useState(false);

  const [catOptions, setCatOptions] = useState([]);

  // Redirect to 404 page if resource is not found
  useQueryNotFoundNavigation({ error });

  const { activeTab, setActiveTab } = useWidgetTabNavigation({
    page: `${PAGES.SOPS}_VERSION`,
    resourceId: sopId,
  });

  const handleNavigationBack = () => {
    if (showActivity) {
      setShowActivity(false);
    } else {
      history.goBack();
    }
  };

  useEffect(() => {
    const categories = systemConfiguration?.system?.sop?.category;
    setCatOptions(() => {
      const catList = categories?.map((cat) => {
        return { label: cat.display, value: cat.id };
      });
      return catList;
    });
  }, [sop?.category, systemConfiguration?.system?.sop?.category]);

  return {
    loading,
    sopId,
    sop,
    showActivity,
    setShowActivity,
    handleNavigationBack,
    version,
    activeTab,
    setActiveTab,
    params,
    catOptions,
    associatedFiles,
  };
};

export default useDetailsVersionData;
